import { inject, Injectable } from "@angular/core";
import {IndividualConfig, ToastrService} from "ngx-toastr";

export interface ToasterConfig extends IndividualConfig {}

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  private _toastr = inject(ToastrService);

  success(title: string, message: string) {
    this._toastr.success(message, title);
  }

  error(title: string, message: string) {
    this._toastr.error(message, title);
  }

  warning(title: string, message: string) {
    this._toastr.warning(message, title);
  }

  info(title: string, message: string) {
    this._toastr.info(message, title);
  }
}
